import React from "react"

const Icon = ({ primary = "#1A1B43", secondary = "url(#paint0_linear_36_746)" }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 17C13.24 17 11 14.76 11 12C11 9.24 13.24 7 16 7C18.76 7 21 9.24 21 12C21 14.76 18.76 17 16 17ZM16 9C14.35 9 13 10.35 13 12C13 13.65 14.35 15 16 15C17.65 15 19 13.65 19 12C19 10.35 17.65 9 16 9Z"
      fill={secondary}
    />
    <path
      d="M25.99 12.67C25.99 12.61 25.99 12.55 25.99 12.5C25.99 6.71 21.5 2 15.99 2C10.48 2 5.99999 6.71 5.99999 12.5C5.99999 12.56 5.99999 12.62 5.99999 12.67C3.63999 13.51 1.98999 15.76 1.98999 18.32C1.98999 21.36 6.68999 27.01 7.22999 27.65C7.41999 27.88 7.69999 28 7.98999 28C8.27999 28 8.55999 27.87 8.74999 27.64C8.80999 27.57 10.05 26.09 11.3 24.25C13.25 27.17 15.04 29.41 15.2 29.62C15.39 29.86 15.68 30 15.98 30C16.28 30 16.57 29.86 16.76 29.62C16.92 29.41 18.71 27.17 20.66 24.25C21.91 26.08 23.15 27.56 23.21 27.64C23.4 27.87 23.68 28 23.97 28C24.26 28 24.54 27.87 24.73 27.65C25.27 27.02 29.97 21.36 29.97 18.32C29.97 15.76 28.32 13.51 25.96 12.67H25.99ZM7.99999 25.41C6.20999 23.14 3.99999 19.83 3.99999 18.32C3.99999 16.81 4.94999 15.33 6.34999 14.69C7.00999 17.05 8.52999 19.87 10.13 22.43C9.37999 23.58 8.56999 24.68 7.98999 25.41H7.99999ZM16 27.37C13.21 23.71 7.99999 16.14 7.99999 12.5C7.99999 7.81 11.59 4 16 4C20.41 4 24 7.81 24 12.5C24 16.14 18.79 23.71 16 27.37ZM24 25.41C23.43 24.67 22.61 23.58 21.86 22.43C23.46 19.87 24.98 17.05 25.64 14.69C27.04 15.33 27.99 16.74 27.99 18.32C27.99 19.9 25.78 23.14 23.99 25.41H24Z"
      fill={primary}
    />
    <defs>
      <linearGradient id="paint0_linear_36_746" x1="21" y1="17" x2="21" y2="7" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FD9317" />
        <stop offset="1" stopColor="#F63B3B" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon
